import axios from "axios";

// API-ul secțiunii `Scopuri și politici`. Tenantul nu se trimite niciodată:
// backendul îl ia din JWT. Mutațiile sunt numai pentru managerul Privacy.
const PAGE_SIZE = 100;
const MAX_PAGES = 50;

// Catalogul complet, cu toate câmpurile, parcurgând paginarea `has_more`.
export const fetchPurposeCatalog = async () => {
  const purposes = [];
  for (let page = 0; page < MAX_PAGES; page += 1) {
    const { data } = await axios.get("/ncrm/privacy/purposes", {
      params: { limit: PAGE_SIZE, offset: page * PAGE_SIZE },
    });
    const items = Array.isArray(data?.items) ? data.items : [];
    purposes.push(...items);
    if (!data?.pagination?.has_more || !items.length) break;
  }
  return purposes;
};

export const fetchPrivacySettings = async () => (await axios.get("/ncrm/privacy/workspace/settings")).data;
export const savePrivacySettings = async (changes) => (await axios.put("/ncrm/privacy/configuration/settings", changes)).data;
export const createPurpose = async (payload) => (await axios.post("/ncrm/privacy/configuration/purposes", payload)).data;
// `expectedVersion` este amprenta scopului primită de la server; un scop schimbat
// între timp răspunde `409 privacy_purpose_conflict`.
export const updatePurpose = async (id, changes, expectedVersion) => (await axios.patch(
  `/ncrm/privacy/configuration/purposes/${id}`,
  { ...changes, ...(expectedVersion ? { expected_version: expectedVersion } : {}) }
)).data;
export const activatePurpose = async (id) => (await axios.post(`/ncrm/privacy/configuration/purposes/${id}/activate`)).data;
export const retirePurpose = async (id) => (await axios.post(`/ncrm/privacy/configuration/purposes/${id}/retire`)).data;

// Impactul retragerii, arătat înainte de confirmare: punctele de contact cu stări pe scop.
export const countPurposeContactPoints = async (purposeId) => {
  const { data } = await axios.get("/ncrm/privacy/workspace/registry", {
    params: { view: "contact_points", purpose_id: purposeId, limit: 1 },
  });
  return Number(data?.total || 0);
};
